// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientQuestionnaire_root__2F5D9","header":"PatientQuestionnaire_header__1UAs8","info":"PatientQuestionnaire_info__2BZRW"};